<ngx-sonner-toaster position="bottom-right" [duration]="5000" closeButton richColors />
<apm-spinner [id]="mainSpinnerName" [name]="mainSpinnerName"></apm-spinner>
<apm-request-tracing-spinner></apm-request-tracing-spinner>

<mat-sidenav-container [hasBackdrop]="true">
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>

  <mat-sidenav #mainSideNav mode="over" position="end" [fixedInViewport]="true">
    <ng-template [cdkPortalOutlet]="sidebarService.sidebarContentPortal()"></ng-template>
  </mat-sidenav>
</mat-sidenav-container>
